import { Button, Popover } from '@mui/material';
import React, { useEffect, useImperativeHandle, useState } from 'react';

const CusPopover = React.forwardRef(({ id, children, content = 'Open popover', shouldClose }, ref) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    if (shouldClose) {
      handleClose();
    }
  }, [shouldClose]);

  const open = Boolean(anchorEl);
  return (
    <>
      {' '}
      <Button aria-describedby={id} variant="outlined" onClick={handleClick}>
        {content}
      </Button>
      <Popover
        id={id}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
      >
        {children}
      </Popover>
    </>
  );
});

export default CusPopover;
